export default "__VITE_ASSET__BIK9ENRQ__"